import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=2ae54e8d&scoped=true&"
var script = {}
import style0 from "./LockIcon.vue?vue&type=style&index=0&id=2ae54e8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae54e8d",
  null
  
)

export default component.exports